import {createDispatchHook, createSelectorHook} from 'react-redux';

import {AppReduxContext} from './context';

import type {AppDispatch, RootState} from './store';
import type {TypedUseSelectorHook} from 'react-redux';

export const useAppDispatch: () => AppDispatch = createDispatchHook(AppReduxContext);
export const useAppSelector: TypedUseSelectorHook<RootState> = createSelectorHook(AppReduxContext);
